import { inject, Injectable } from '@angular/core';
import { ForgotCompanyCredentials } from '@pages/login-recovery-options/models/forgot-company-credentials.interface';
import { ForgotPasswordCredentials } from '@pages/login-recovery-options/models/forgot-password-credentials.interface';
import { ForgotUsernameCredentials } from '@pages/login-recovery-options/models/forgot-username-credentials.interface';
import { Store } from '@ngxs/store';
import {
  RecoverCredentialsByCompany,
  RecoverCredentialsByPassword,
  RecoverCredentialsByUsername,
} from '@pages/login-recovery-options/store/actions/login-recovery.actions';
import { LoginRecoveryState } from '@pages/login-recovery-options/store/state/login-recovery.state';
import { ResetStateFacade } from '@core/store/facades/reset-state.facade';

@Injectable({
  providedIn: 'root',
})
export class LoginRecoveryFacade {
  private readonly store = inject(Store);
  private readonly resetStateFacade = inject(ResetStateFacade);

  readonly loading = this.store.selectSignal(LoginRecoveryState.loading);
  readonly recoveryCredentials = this.store.selectSignal(LoginRecoveryState.recoveryCredentials);
  readonly recoveryOption = this.store.selectSignal(LoginRecoveryState.recoveryOption);
  readonly errorMessageTranslationKey = this.store.selectSignal(LoginRecoveryState.errorMessageTranslationKey);

  recoverCredentialsByUsername(credentials: ForgotUsernameCredentials): void {
    this.store.dispatch(new RecoverCredentialsByUsername(credentials));
  }

  recoverCredentialsByCompany(credentials: ForgotCompanyCredentials): void {
    this.store.dispatch(new RecoverCredentialsByCompany(credentials));
  }

  recoverCredentialsByPassword(credentials: ForgotPasswordCredentials): void {
    this.store.dispatch(new RecoverCredentialsByPassword(credentials));
  }

  clearState(): void {
    this.resetStateFacade.clearState(LoginRecoveryState);
  }
}
